import { render, staticRenderFns } from "./CompanyAddressSettings.vue?vue&type=template&id=1c89220d&scoped=true&"
import script from "./CompanyAddressSettings.vue?vue&type=script&lang=js&"
export * from "./CompanyAddressSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c89220d",
  null
  
)

export default component.exports